"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useTrackException;

var _react = require("react");

var _createCustomEvent = _interopRequireDefault(require("../Utils/createCustomEvent"));

var _useReadTelemetryDimensions = _interopRequireDefault(require("./internal/useReadTelemetryDimensions"));

var _useWebChatUIContext2 = _interopRequireDefault(require("./internal/useWebChatUIContext"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function useTrackException() {
  var _useWebChatUIContext = (0, _useWebChatUIContext2.default)(),
      onTelemetry = _useWebChatUIContext.onTelemetry;

  var readTelemetryDimensions = (0, _useReadTelemetryDimensions.default)();
  return (0, _react.useCallback)(function (error) {
    var fatal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (!(error instanceof Error)) {
      return console.warn('botframework-webchat: "error" passed to "useTrackException" must be specified and of type Error.');
    }

    onTelemetry && onTelemetry((0, _createCustomEvent.default)('exception', {
      dimensions: _objectSpread({}, readTelemetryDimensions()),
      error: error,
      fatal: !!fatal
    }));
  }, [onTelemetry, readTelemetryDimensions]);
}